import { render } from "./Matching.vue?vue&type=template&id=46985992&scoped=true&ts=true&lang=pug"
import script from "./Matching.vue?vue&type=script&lang=ts"
export * from "./Matching.vue?vue&type=script&lang=ts"

import "./Matching.vue?vue&type=style&index=0&id=46985992&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46985992"]])

export default __exports__